var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.productDatasheetUrl
    ? _c(
        "a",
        {
          staticClass:
            "btn btn--link w-100 text-shade-darker font-weight-light text-decoration-none",
          attrs: { href: _vm.productDatasheetUrl, target: "_blank" },
        },
        [
          _c(
            "svg",
            {
              staticClass: "svg-icon text-xxlarge icon-pdf",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 60 60",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M39.8 47.6c1.2 0 2.2-1 2.2-2.2V14.6c0-1.2-1-2.2-2.2-2.2H23.9c-.9 0-2 .5-2.7 1.1L15 19.7c-.6.6-1.1 1.8-1.1 2.7v23.1c0 1.2 1 2.2 2.2 2.2h23.7zm0-33v30.8H16.2V22.3h5.5c1.2 0 2.2-1 2.2-2.2v-5.5h15.9zm-18.1 1.5v4h-4l4-4z",
                  fill: "#3A3A39",
                },
              }),
              _vm._v(" "),
              _c("path", { attrs: { fill: "#fff", d: "M19 24h35v17H19z" } }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  fill: "#3A3A39",
                  d: "M27.9 34.3v3h-1.8v-8.6H29c.6 0 1.1.1 1.5.2.4.1.8.3 1.1.6.3.2.5.5.6.9.1.3.2.7.2 1.1 0 .4-.1.8-.2 1.2s-.3.7-.6.9c-.3.3-.6.5-1.1.6-.4.1-.9.2-1.5.2h-1.1zm0-1.4H29c.6 0 1-.1 1.2-.4s.4-.6.4-1.1c0-.2 0-.4-.1-.6-.1-.2-.2-.3-.3-.5-.1-.1-.3-.2-.5-.3h-1.8v2.9zm13.7 0c0 .6-.1 1.2-.3 1.7s-.5 1-.9 1.4c-.4.4-.9.7-1.4.9-.5.2-1.1.3-1.8.3h-3.3v-8.6h3.3c.7 0 1.3.1 1.8.3.5.2 1 .5 1.4.9.4.4.7.8.9 1.4s.3 1.1.3 1.7zm-1.9 0c0-.5-.1-.9-.2-1.2-.1-.4-.3-.7-.5-.9s-.5-.4-.8-.6-.7-.2-1.1-.2h-1.5v5.8h1.5c.4 0 .8-.1 1.1-.2.3-.1.6-.3.8-.6s.4-.6.5-.9.2-.7.2-1.2zm8.9-4.3V30h-3.7v2.4H48v1.4h-3.1v3.5h-1.8v-8.6h5.5z",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm._f("translate")("txtDatenblatt")))]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }